import { Reducer } from "redux";
import { Action, ActionType } from "../../actions";
import { ResultsData } from "../../state/ShoppingDiagnostics/ResultsData";


const updateResultsData: Reducer<ResultsData> = (state: ResultsData = new ResultsData(), action: Action<ActionType, ResultsData>) => {
  switch (action.type) {
    case ActionType.SHOPPING_DIAGNOSTICS_DATA_FETCHED:
      return {
        ...state,
        shoppingResults: action.data.shoppingResults,
        correlationId: action.data.correlationId,
        shoppingRequestDurationMs:
          action.data.shoppingRequestDurationMs !== undefined ? action.data.shoppingRequestDurationMs : state.shoppingRequestDurationMs,
      };
    case ActionType.SHOPPING_DIAGNOSTICS_DATA_RESET_LIVE:
      return new ResultsData();
    default:
      return state;
  }
};

export default updateResultsData;
